import { Fragment, useState } from "react";
import classNames from "classnames";

import { Caption } from "@ascendnow/shared";

import styles from "./AscResourceVideoCard.module.scss";
import { ReactComponent as LikeIcon } from "../../assets/icons/like.svg";
import { ReactComponent as PlayIcon } from "../../assets/icons/play-circle.svg";
import AscFileViewModal from "../AscFileViewModal/AscFileViewModal";

export interface AscResourceVideoCardProps {
  title: string;
  isFavorite: boolean;
  thumbnail: string;
  videoSrc: string;
  className?: string;
  fileName?: string;
  videoUrl?: string;
  mimeType?: string;
  handleFavBtn?: () => void;
  captions?: Caption[];
}

export default function AscResourceVideoCard({
  title,
  isFavorite,
  thumbnail,
  videoSrc,
  videoUrl,
  className,
  fileName,
  mimeType,
  handleFavBtn,
  captions,
}: AscResourceVideoCardProps) {
  const [videoModal, setToggleVideoModal] = useState(false);
  return (
    <Fragment>
      <AscFileViewModal
        visible={videoModal}
        fileName={fileName || title}
        mimeType={mimeType}
        fileUrl={videoSrc}
        videoUrl={videoUrl}
        videoCaptions={
          captions && captions.length > 0 ? captions[0]?.translations : []
        }
        fileType={"video"}
        onClose={() => setToggleVideoModal(false)}
      />
      <div
        data-testid="asc-resource-video-card"
        className={classNames(styles.video, className)}
      >
        <div
          className={styles.videoThumbnail}
          style={{ backgroundImage: `url(${thumbnail})` }}
          onClick={() => setToggleVideoModal(true)}
        >
          <PlayIcon className={styles.videoPlayIcon} tabIndex={0} />
        </div>
        <div className={styles.videoDetails}>
          <LikeIcon
            onClick={() => {
              if (handleFavBtn) {
                handleFavBtn();
              }
            }}
            className={isFavorite ? styles.favorite : ""}
          />
          <h5 className={styles.videoTitle}>{title}</h5>
        </div>
      </div>
    </Fragment>
  );
}
